import { gql } from '@apollo/client'

export const deleteFileFromCloud = gql`
  mutation DeleteFileFromCloud($list: [String]!) {
    deleteFileFromCloud(list: $list)
  }
`
